import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';
import { useCtwQuery } from '@ctw/shared/hooks/use-ctw-query';
import { getApiServiceBaseUrl } from '@ctw/shared/utils/environments';
import { QUERY_KEY_HOTLOAD_PATIENT } from '@ctw/shared/utils/query-keys';

/**
 * This is a temporary hook to trigger the hot-loading of a patient's records for search.
 *
 * @param upid The UPID of the patient
 */
export const useTriggerHotloadPatient = (upid?: string) => {
  const hasPatientRecordSearchFqsFeature = useFeatureFlag('ctw-patient-record-search-fqs');

  useCtwQuery({
    queryId: QUERY_KEY_HOTLOAD_PATIENT,
    queryKey: [upid],
    queryFn: async ({ requestContext, ctwFetch }) => {
      const { data } = await ctwFetch(
        `${getApiServiceBaseUrl({ service: 'fqs', env: requestContext.env })}/hotload`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${requestContext.authToken}`,
          },
          body: JSON.stringify({
            upid,
          }),
          mode: 'cors',
        },
      );

      return data;
    },
    enabled: hasPatientRecordSearchFqsFeature && !!upid,
  });
};
